export default {
    dataSource: {
        type: Object,
        default: undefined
    }, 
    autoBind: {
        type: Boolean,
        default: undefined
    }, 
    reorderable: {
        type: Boolean,
        default: undefined
    }, 
    excel: {
        type: Object,
        default: undefined
    }, 
    pdf: {
        type: Object,
        default: undefined
    }, 
    filterable: {
        type: Boolean,
        default: undefined
    }, 
    sortable: {
        type: [Boolean, Object],
        default: undefined
    }, 
    columnWidth: {
        type: Number,
        default: undefined
    }, 
    height: {
        type: [Number, String],
        default: undefined
    }, 
    columnHeaderTemplate: {
        type: [String, Function],
        default: undefined
    }, 
    dataCellTemplate: {
        type: [String, Function],
        default: undefined
    }, 
    kpiStatusTemplate: {
        type: [String, Function],
        default: undefined
    }, 
    kpiTrendTemplate: {
        type: [String, Function],
        default: undefined
    }, 
    rowHeaderTemplate: {
        type: [String, Function],
        default: undefined
    }, 
    messages: {
        type: Object,
        default: undefined
    }, 

    // Events
    dataBinding: {
        type: Function,
        default: undefined
    },  
    dataBound: {
        type: Function,
        default: undefined
    },  
    expandMember: {
        type: Function,
        default: undefined
    },  
    collapseMember: {
        type: Function,
        default: undefined
    },  
    excelExport: {
        type: Function,
        default: undefined
    },  
    pdfExport: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-pivotgrid-vue-wrapper/src/KendoPivotGrid/PivotGridProps.js